window.HPLab = window.HPLab || {};
HPLab.QuestionBuilder = {
  build: function (allQuestions, selectedSymptoms, maxQuestions) {
    maxQuestions = maxQuestions || 6;
    var matched = allQuestions.filter(function (q) {
      return q.symptoms.some(function (s) {
        return selectedSymptoms.indexOf(s) !== -1;
      });
    });
    matched.sort(function (a, b) {
      return (a.priority || 99) - (b.priority || 99);
    });
    var seen = {};
    var result = [];
    matched.forEach(function (q) {
      if (!seen[q.key] && result.length < maxQuestions) {
        seen[q.key] = true;
        result.push(q);
      }
    });
    return result;
  }
};
